/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Marked_BodyInputs */

const en_us2_workout_quick_marked_body = /** @type {(inputs: Workout_Quick_Marked_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It counts as a workout and the plan moves on to the next one. With no sets logged, your targets stay as they are.`)
};

const pt_br2_workout_quick_marked_body = /** @type {(inputs: Workout_Quick_Marked_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta como treino e o plano segue para o próximo. Sem séries registradas, as metas ficam como estão.`)
};

const es_419_workout_quick_marked_body = /** @type {(inputs: Workout_Quick_Marked_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta como entrenamiento y el plan pasa al siguiente. Sin series registradas, tus metas quedan como están.`)
};

const pt_pt2_workout_quick_marked_body = /** @type {(inputs: Workout_Quick_Marked_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta como treino e o plano segue para o próximo. Sem séries registadas, as metas ficam como estão.`)
};

const fr_fr2_workout_quick_marked_body = /** @type {(inputs: Workout_Quick_Marked_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle compte comme une séance et le programme passe à la suivante. Sans séries enregistrées, tes objectifs restent tels quels.`)
};

const de_de2_workout_quick_marked_body = /** @type {(inputs: Workout_Quick_Marked_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es zählt als Training und der Plan geht zum nächsten weiter. Ohne erfasste Sätze bleiben deine Ziele, wie sie sind.`)
};

const it_it2_workout_quick_marked_body = /** @type {(inputs: Workout_Quick_Marked_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta come allenamento e la scheda passa al prossimo. Senza serie registrate, gli obiettivi restano come sono.`)
};

/**
* | output |
* | --- |
* | "It counts as a workout and the plan moves on to the next one. With no sets logged, your targets stay as they are." |
*
* @param {Workout_Quick_Marked_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_marked_body = /** @type {((inputs?: Workout_Quick_Marked_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Marked_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_marked_body(inputs)
	if (locale === "es-419") return es_419_workout_quick_marked_body(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_marked_body(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_marked_body(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_marked_body(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_marked_body(inputs)
	return en_us2_workout_quick_marked_body(inputs)
});
export { workout_quick_marked_body as "workout-quick.marked_body" }